import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f105537"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "no-mb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Informatie over uw bouwnummer", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Projectnaam:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Uw nieuwe adres:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "EAN-code energieaansluiting:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Planregistratienummer Woningborg:", -1))
const _hoisted_8 = { class: "no-mb" }
const _hoisted_9 = {
  href: "https://www.woningborg.nl/het-certificaat",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Belangrijke data", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sluitingsdatum modulair:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sluitingsdatum ruwbouw:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sluitingsdatum afbouw:", -1))
const _hoisted_14 = { class: "no-mb" }

import { computed } from 'vue'
import { ls } from '@/ls'
import { useRouter } from 'vue-router'
import { ExportOutlined, ThunderboltFilled } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingDetailsMobile',
  setup(__props) {

const router = useRouter()
const building = computed(() => ls.get('building'))
const buildingCount = computed(() => ls.get('buildings').length)

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { "body-style": { padding: 0 } }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"max-width":"100%"},
                  src: _unref(building).projectBanner ? _unref(building).projectBanner.url : '/img/logos/Empty_Project_Banner.png'
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          type: "flex",
          gutter: [16,16]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { flex: "80px" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_avatar, {
                  shape: "square",
                  size: 80,
                  src: _unref(building).projectLogo ? _unref(building).projectLogo.url : '/img/logos/Woonon_Square_Logo.png'
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { flex: "auto" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_2, "Bouwnummer " + _toDisplayString(_unref(building).number), 1),
                (_unref(buildingCount) > 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      class: "switch-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'BuildingSelector' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Wisselen van bouwnummer")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { gutter: [16, 16] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("p", null, _toDisplayString(_unref(building).project_name ? _unref(building).project_name : '-'), 1),
                _hoisted_5,
                _createElementVNode("p", null, _toDisplayString(_unref(building).address && _unref(building).zipcode && _unref(building).city ? `${_unref(building).address}, ${_unref(building).zipcode} ${_unref(building).city}` : '-'), 1),
                _hoisted_6,
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_unref(building).ean_power ? _unref(building).ean_power : '-') + " ", 1),
                  (_unref(building)?.ean_power)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        size: "small",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'EnergyComparison', query: { gas_available: 0 } })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ThunderboltFilled))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_unref(building).certificate ? _unref(building).certificate : '-') + " ", 1),
                  _createElementVNode("a", _hoisted_9, [
                    _createVNode(_unref(ExportOutlined))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("p", null, _toDisplayString(_unref(building).end_modular ? new Date(_unref(building).end_modular).toLocaleString('nl-NL', { day: 'numeric',  month: 'long',  year: 'numeric',  hour: '2-digit', minute:'2-digit' }) + ' uur' : '-'), 1),
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString(_unref(building).end_carcass ? new Date(_unref(building).end_carcass).toLocaleString('nl-NL', { day: 'numeric',  month: 'long',  year: 'numeric',  hour: '2-digit', minute:'2-digit' }) + ' uur' : '-'), 1),
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(building).end_completion ? new Date(_unref(building).end_completion).toLocaleString('nl-NL', { day: 'numeric',  month: 'long',  year: 'numeric',  hour: '2-digit', minute:'2-digit' }) + ' uur' : '-'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})